import { normalizeErc20AbiForToken } from '../../approve/logic/normalizeErc20Abi'
import { allowanceQueryKey, readAllowance } from '../../approve/logic/query'
import { ResetApprovalAction } from '../types'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'

export function createResetApprovalActionConfig(action: ResetApprovalAction, context: ActionContext): ActionConfig {
  const { wagmiConfig, account, chainId } = context

  const allowanceOptions = {
    token: action.token.address,
    spender: action.spender,
    wagmiConfig,
    account,
    chainId,
  }

  return {
    getInitialParams: async () => {
      const data = await readAllowance(allowanceOptions)
      return { canBeSkipped: canBeSkipped(data, action) }
    },

    getWriteConfig: () => {
      const address = action.token.address

      return ensureConfigTypes({
        address,
        abi: normalizeErc20AbiForToken(chainId, address),
        functionName: 'approve',
        args: [action.spender, 0n],
      })
    },

    verifyTransaction: async () => {
      const data = await readAllowance(allowanceOptions)
      return { success: data === 0n }
    },

    invalidates: () => [allowanceQueryKey({ token: action.token.address, spender: action.spender, account, chainId })],
  }
}

function canBeSkipped(allowance: bigint, action: ResetApprovalAction): boolean {
  return allowance === 0n || allowance >= action.token.toBigInt(action.requiredValue ?? action.value)
}
